import React, { useCallback } from 'react';
import { RiMoonLine, RiSunLine } from 'react-icons/ri';

import { SET_EDITOR_PREFERENCES } from '../../actions/setEditorPreferences';
import { useStore } from '../../hooks';
import {
  normalizeUiTheme,
  persistUiTheme,
  UI_THEMES,
} from '../../../../theme/uiTheme';

const EditorThemeToggle = () => {
  const { dispatch, editorPreferences = {}, t } = useStore();
  const theme = normalizeUiTheme(editorPreferences.uiTheme);

  const toggleTheme = useCallback(() => {
    const next = theme === UI_THEMES.DARK ? UI_THEMES.LIGHT : UI_THEMES.DARK;
    dispatch({
      type: SET_EDITOR_PREFERENCES,
      payload: { uiTheme: next },
    });
    persistUiTheme(next);
  }, [dispatch, theme]);

  const isLight = theme === UI_THEMES.LIGHT;
  const label = isLight ? t('themeLight') : t('themeDark');

  return (
    <button
      type="button"
      className="respark_topbar-btn respark_topbar-theme-toggle"
      title={t('themeToggleTitle')}
      aria-label={label}
      aria-pressed={isLight}
      onClick={toggleTheme}
    >
      {isLight ? (
        <RiSunLine size={18} aria-hidden />
      ) : (
        <RiMoonLine size={18} aria-hidden />
      )}
    </button>
  );
};

export default EditorThemeToggle;
